export default "__VITE_ASSET__a0867b05__"